<!--
 * @Description: 登录页
 * @Author: zml
 * @Date: 2023-04-14 15:34:22
 * @LastEditors: zml
 * @LastEditTime: 2025-05-13 10:47:46
-->
<template>
  <div class="login-page">
    <h1>{{ $hs('华晟科技实业有限公司','BESTWIN TECH INDUSTRY HK LIMITED','Гонконгская компания с ограниченной ответственностью') }}</h1>
    <div class="flex-box">
      <div class="left">
        <div class="image2">
          <img src="../../assets/HaSheng/login-bg2.png" alt srcset />
        </div>
      </div>
      <div class="login-box">
        <div class="right">
          <div v-show="modelName === 'login'" class="login">
            <div class="title">{{ $hs('登录华晟科技账号','Login to BESTWIN TECH INDUSTRY HK LIMITED','Компания Bestwin Technology Industries Hong Kong Ltd.') }}</div>
            <el-form :model="loginForm" ref="loginForm" :rules="loginRules" label-position="top">
              <el-form-item prop="email" :label="$hs('邮箱','Email','Почтовый ящик')" required>
                <el-input v-model="loginForm.email"></el-input>
              </el-form-item>
              <el-form-item prop="userPassword" required>
                <el-input v-model="loginForm.userPassword" auto-complete="new-password" type="password" @keyup.enter.native="loginSubmit"></el-input>
                <template #label name="name">
                  <div class="label">
                    <span>{{ $hs('密码','Password','Пароль') }}</span>
                    <span class="reset-pass" @click="resetClcik">{{ $hs('忘记密码','Forgot Password','Забыть пароль') }}</span>
                  </div>
                </template>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="loginSubmit" class="btn" :loading="loading">{{ $hs('登录','Log on','Регистрация') }}</el-button>
            </span>
            <div class="footer-btn">
              <div>
                <span>{{ $hs('还没有账号','No account yet','Нет аккаунта.') }}?&nbsp;&nbsp;</span>
                <span class="signup" @click="registerClick">{{ $hs('立即注册','Register Now','Немедленная регистрация') }}</span>
              </div>
              <div>
                <el-select v-model="language" @change="changeLanguage" style="width:120px" size="mini">
                  <el-option
                    style="display:flex; align-items: center;"
                    v-for="(item, index) in options"
                    :key="index"
                    v-show="getLanguageConfig.languageList && getLanguageConfig.languageList.includes(item.value)"
                    :value="item.name"
                  >
                    <span style="font-size: 12px;">{{ item.name }}</span>
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-show="modelName === 'register'" class="register">
            <div class="title">{{ $hs('注册华晟科技账号','Register a BESTWIN TECH INDUSTRY HK LIMITED','Регистрация BESTWIN Technology Industries Hong Kong Limited') }}</div>
            <el-form :model="registerForm" ref="registerForm" label-position="top" :rules="registerRules">
              <el-form-item prop="email" :label="$hs('邮箱','Email','Почтовый ящик')" required>
                <el-input v-model="registerForm.email" :placeholder="$t('KRF.PleaseEmial')"></el-input>
              </el-form-item>
              <el-form-item prop="userPassword" :label="$hs('密码','Password','Пароль')" required>
                <el-input type="password" v-model="registerForm.userPassword" :placeholder="$t('KRF.PleasePassword')"></el-input>
              </el-form-item>
              <el-form-item prop="valideCode" :label="$hs('验证码','Valide code','Код проверки')" class="valide-code" required>
                <el-input v-model="registerForm.valideCode" :placeholder="$t('KRF.PleaseCode')" @keyup.enter.native="registerSubmit"></el-input>
                <img v-if="JSON.stringify(codeData) !== '{}'" @click="getCode" :src="codeData.valideCode" title="看不清楚？换一张" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="registerSubmit" class="btn" :loading="loading">{{$hs('注册','Sign in','Регистрация')}}</el-button>
            </span>
            <div class="footer-btn">
              <div>
                <span class="signup" @click="loginClick">{{$hs('返回登录','Return to login','Вернуться в Регистрация')}}</span>
              </div>
              <div>
                <el-select v-model="language" @change="changeLanguage" style="width:120px" size="mini">
                  <el-option
                    style="display:flex; align-items: center;"
                    v-for="(item, index) in options"
                    :key="index"
                    v-show="getLanguageConfig.languageList && getLanguageConfig.languageList.includes(item.value)"
                    :value="item.name"
                  >
                    <span style="font-size: 12px;">{{ item.name }}</span>
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-show="modelName === 'reset'" class="reset">
            <div class="title">{{$hs('重置密码','Reset password','Сбросить пароль')}}</div>
            <el-form :model="resetForm" ref="resetForm" label-position="top" :rules="resetRules">
              <el-form-item prop="email" :label="$hs('邮箱','Email','Почтовый ящик')" required>
                <el-input v-model="resetForm.email"></el-input>
              </el-form-item>
              <el-form-item prop="code" :label="$hs('验证码','Valide code','Код проверки')" required>
                <div style="display:flex">
                  <el-input v-model="resetForm.code"></el-input>
                  <el-button class="get-code" @click="getEmailCode" :loading="loading">{{$hs('获取验证码','Obtain verification code','Получение кода проверки')}}</el-button>
                </div>
              </el-form-item>
              <el-form-item prop="password" :label="$t('NT.newPassword')" required>
                <el-input type="password" v-model="resetForm.password"></el-input>
              </el-form-item>
              <el-form-item prop="password1" :label="$t('NT.confirmPassword')" required>
                <el-input type="password" v-model="resetForm.password1"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="resetSubmit" class="btn">{{$hs('重置','Reset','Сбросить')}}</el-button>
            </span>
            <div class="footer-btn">
              <div>
                <span class="signup" @click="loginClick">{{$hs('返回登录','Return to login','Вернуться в Регистрация')}}</span>
              </div>
              <div>
                <el-select v-model="language" @change="changeLanguage" style="width:120px" size="mini">
                  <el-option
                    style="display:flex; align-items: center;"
                    v-for="(item, index) in options"
                    :key="index"
                    v-show="getLanguageConfig.languageList && getLanguageConfig.languageList.includes(item.value)"
                    :value="item.name"
                  >
                    <span style="font-size: 12px;">{{ item.name }}</span>
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="image">
      <img src="../../assets/HaSheng/login-bg1.png" alt srcset />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { LoginMemberByEmailNoValideCode, GetValideCode, RegisterByEmail, GetEmailValideCode, UpdatePasswordByEmail } from '@/api/login'
import { setDocumentTitle } from '@/utils/domUtil'
export default {
  data() {
    // 检验邮件
    let regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
    let checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('inputEmail')))
      }
      if (regEmail.test(value)) {
        // 合法邮箱
        callback()
      } else {
        // 错误邮箱
        callback(new Error(this.$t('inputEmailRules')))
      }
    }
    return {
      loading: false,
      modelName: 'login',
      codeData: {},

      // 登录表单
      loginForm: {
        email: '',
        userPassword: '',
        isAudit: true
      },
      loginRules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      // 注册表单
      registerForm: {
        email: '',
        userPassword: '',
        keyCode: 0,
        valideCode: ''
      },
      registerRules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },

      // 忘记密码表单
      resetForm: {
        email: '',
        code: '',
        password: '',
        password1: ''
      },
      resetRules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },

      options: [
        { name: 'English', value: 'en' },
        { name: '中文', value: 'zh-Hans' },
        { name: 'русский язык', value: 'ru' }
      ],
      language: this.$t('language')
    }
  },
  computed: {
    // ...mapState('operate', ['language']),
    ...mapGetters('setting', {
      getSetting: 'get_setting',
      getLanguageConfig: 'get_language_config'
    })
  },
  created() {
    this.getCode()
  },
  mounted() {},
  methods: {
    ...mapActions('user', ['set_userInfo']),
    ...mapActions('operate', {
      set_language: 'set_language'
    }),

    // 登录
    loginClick() {
      this.modelName = 'login'
    },

    // 注册
    registerClick() {
      this.modelName = 'register'
    },

    // 重置密码
    resetClcik() {
      this.modelName = 'reset'
    },

    // 提交登录
    loginSubmit() {
      this.$refs.loginForm.validate(values => {
        if (values) {
          this.loading = true
          LoginMemberByEmailNoValideCode(this.loginForm)
            .then(res => {
              if (res.success) {
                this.set_userInfo(res.data)
                this.$message.success(this.$t('loginSuccess'))
                this.$refs.loginForm.resetFields()
                this.$router.push('/home')
                window.location.reload()
              }
            })
            .catch(err => {
              if (err.includes('D1632') || err.includes('D1631')) {
                this.$message.error(this.$t('CodeError'))
              } else if (err.includes('D1629')) {
                this.$message.error(this.$t('notreviewed'))
              } else if (err.includes('D1628')) {
                this.form.userPassword = ''
                this.$message.error(this.$t('loginError'))
              }
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$message.error(
            this.$hs('登录失败，邮箱或密码有误', 'Login failed, incorrect email or password', 'Ошибка входа в систему, ошибка почтового ящика или пароля')
          )
        }
      })
    },

    // 提交注册
    registerSubmit() {
      this.$refs.registerForm.validate(values => {
        if (values) {
          this.loading = true
          RegisterByEmail({ ...this.registerForm, keyCode: this.codeData.keyCode })
            .then(() => {
              this.$message.success(this.$t('regSuccess'))
              this.close()
              this.modelName = 'login'
            })
            .catch(err => {
              if (err.includes('D1632') || err.includes('D1631')) {
                this.$message.error(this.$t('CodeError'))
              } else if (err.includes('D1630')) {
                this.$message.error(this.$t('resUserError'))
              }
            })
            .finally(() => {
              this.getCode()
              this.loading = false
            })
        } else {
          this.$message.error(
            this.$hs('注册失败，填写信息有误', 'Registration failed, incorrect information filled in', 'Ошибка регистрации, неправильное заполнение информации')
          )
        }
      })
    },

    // 重置密码表单
    resetSubmit() {
      this.$refs.resetForm.validate(values => {
        if (values) {
          this.loading = true
          UpdatePasswordByEmail(this.resetForm)
            .then(res => {
              if (res.success) {
                this.$message.success(this.$hs('重置成功', 'Reset successful', 'Удалось сбросить'))
                this.close()
                this.modelName = 'login'
              }
            })
            .catch(err => {
              this.$message.error(err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$message.error(
            this.$hs('重置失败，填写信息有误', 'Reset failed, incorrect information filled in', 'Ошибка сброса, неправильное заполнение информации')
          )
        }
      })
    },

    // 重置表单
    close() {
      this.$refs.loginForm.resetFields()
      this.$refs.registerForm.resetFields()
      this.$refs.resetForm.resetFields()
    },

    // 获取邮箱验证码
    getEmailCode() {
      let regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
      if (regEmail.test(this.resetForm.email)) {
        GetEmailValideCode({
          email: this.resetForm.email,
          language: this.$hs('zh-Hans', 'en', 'es')
        })
          .then(res => {
            if (res.success) {
              this.$message.success(
                this.$hs(
                  '验证码已经发送到你的邮箱',
                  'The verification code has been sent to your email',
                  'Код подтверждения отправлен на ваш почтовый ящик.'
                )
              )
            } else {
              this.$message.error(JSON.stringify(res.message))
            }
          })
          .catch(err => {
            this.$message.error(err)
          })
      } else {
        this.$message.warning(this.$hs('请输入正确的邮箱', 'Please enter the correct email address', 'Введите правильный почтовый ящик.'))
      }
    },

    // 获取验证码
    getCode() {
      GetValideCode()
        .then(res => {
          this.codeData = res.data
        })
        .catch(err => {
          this.$message.error(err)
        })
    },

    changeLanguage(e) {
      if (e === 'English') {
        this.$i18n.locale = 'en'
        this.set_language('en')
        setDocumentTitle(this.getSetting.enTitle)
        // window.location.reload()
      } else if (e === '中文') {
        this.$i18n.locale = 'zh'
        this.set_language('zh')
        setDocumentTitle(this.getSetting.title)
        // window.location.reload()
      } else if (e === 'русский язык') {
        this.$i18n.locale = 'ru'
        this.set_language('ru')
        setDocumentTitle(this.getSetting.rusTitle)
        // window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  height: 100vh;
  background: linear-gradient(180deg, #f7c873, #fbbb74 48%, #fca676, #fac1a5);
  h1 {
    position: fixed;
    top: 60px;
    left: 60px;
    color: #fff;
    letter-spacing: 1.3px;
    // line-height: 30px;
    font-size: 26px;
    margin: 0;
    z-index: 3;
  }
  .image {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    img {
      width: 100%;
    }
  }

  :deep(.el-form-item__label) {
    width: 100%;
    display: flex;
    line-height: 32px !important;
    padding: 0px;

    .label {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }

  .flex-box {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      flex: 50%;
      .image2 {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 60px 0 0;
      }
    }
    .login-box {
      display: flex;
      width: 50%;
      // height: 648px;
      padding: 0 0 0 150px;
      box-sizing: border-box;
      .right {
        width: 500px;
        padding: 30px 40px;
        background-color: #fafafa;
        box-sizing: border-box;
        .title {
          font-size: 24px;
          color: #222222;
          font-family: MicrosoftYaHei;
          letter-spacing: 1.2px;
          padding: 13px 0 30px;
        }

        .reset-pass {
          color: #fe6a00;
          cursor: pointer;
          &:hover {
            transform: scale(1.1);
          }
        }

        :deep .el-form {
          padding: 10px 0 0 0;
          .valide-code {
            .el-input {
              margin: 0 10px 0 0;
            }
            .el-form-item__content {
              display: flex;
            }
          }

          .el-form-item {
            margin: 0 0 4px 0;
          }
          .el-form-item__error {
            display: none;
          }
        }
        .login-btn {
          width: 100%;
          margin: 10px 0 0;
        }

        .footer-btn {
          display: flex;
          justify-content: space-between;
          margin: 30px 0 20px 0;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0.7px;

          .signup {
            display: inline-block;
            color: #fe6a00;
            cursor: pointer;
            line-height: 28px;
            &:hover {
              transform: scale(1.1);
            }
          }
        }

        .get-code {
          margin: 0 0 0 10px;
        }
        :deep .el-tabs__item.is-active {
          color: #a2ce59 !important;
        }
        :deep .el-tabs__active-bar {
          background-color: #a2ce59 !important;
        }
        .dialog-footer {
          .btn {
            margin-top: 20px;
            width: 100%;
            background: linear-gradient(0deg, #ff6e06, #ff7a1c 99%, #ff862f);

            border: 0;
          }
        }
      }
    }
  }

  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #fff;
    font-size: 12px;
    color: #666666;
    font-family: MicrosoftYaHei;
    height: 56px;
    letter-spacing: 0.6px;
    & > div {
      height: 100%;
      width: 1200px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin: auto;
    }

    .copyright {
      text-align: center;
    }

    .language {
      position: absolute;
      right: 0;
    }
  }
}
</style>